export default __webpack_public_path__ + "static/Artificial_Intelligence-1ef8a0d93b22280f22c55909746dd745.webp";